import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { environment } from '@fitness-force/environments';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root',
})
export class WaiverManagementService {
  private http = inject(HttpClient);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  createWaiver(payload: any, tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.WAIVER.CREATE_WAIVER
      .replace('{tenant_id}', tenantId.toString());
    return this.http
      .post(
        url,
        payload,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateWaiver(waiverId: number, updatePayload: any, tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.WAIVER.UPDATE_WAIVER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{waiver_id}', waiverId.toString()); 

    return this.http
      .put(
        url,
        updatePayload,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getWaivers(tenantId: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.WAIVER.GET_WAIVERS
      .replace('{tenant_id}', tenantId.toString());

    return this.http
      .get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getWaiverById(waiverId: number, tenantId: number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.WAIVER.GET_WAIVER_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{waiver_id}', waiverId.toString());
    return this.http
      .get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markActiveWaiver(waiverId: number, tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.WAIVER.MARK_WAIVER_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{waiver_id}', waiverId.toString());
    return this.http
      .post(url, {}, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActiveWaiver(waiverId: number, tenantId: number) {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.WAIVER.MARK_WAIVER_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{waiver_id}', waiverId.toString());  
    return this.http
      .post(url, {}, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
} 